import { Events, Dom, gsap } from '@univers-agency/jupiter'

/*
All the lottie animations
*/

export default class Animations {
  constructor (parade) {
    this.parade = parade
    this.$parade = Dom.find('.parade')
    this.$handles = []
    this.$svgAnimations = Dom.all('[id^="ANIMATE"]')
    window.addEventListener(Events.APPLICATION_RESIZE, this.onResize.bind(this))
    this.$animations = []
    Array.from(this.$svgAnimations).forEach(a => { a.classList.add('stopped') })
    gsap.set('#gjengen', { opacity: 0 })
    gsap.set('#sykkel', { opacity: 0 })
    this.playerGjengen = document.querySelector('#gjengen lottie-player')
    this.playerSykkel = document.querySelector('#sykkel lottie-player')
  }

  placeBike () {
    this.svgBike = this.playerSykkel.shadowRoot.querySelector('svg')

    if (!this.svgBike) {
      return
    }

    gsap.to(this.svgBike, { width: 'auto', position: 'absolute' })

    const bike = Dom.find('#sykkel')
    const width = this.svgBike.clientWidth
    gsap.set(bike, { width })

    const bikeRect = bike.getBoundingClientRect()
    const spot = Dom.find('#POSITION-SYKKEL')
    const spotRect = spot.getBoundingClientRect()

    gsap.set(bike, { opacity: 1, left: this.parade.$el.scrollLeft + spotRect.x - (bikeRect.width / 2) })
  }

  placeGang () {
    this.svgGjengen = this.playerGjengen.shadowRoot.querySelector('svg')

    if (!this.svgGjengen) {
      return
    }

    gsap.to(this.svgGjengen, { width: 'auto', position: 'absolute' })

    const gang = Dom.find('#gjengen')
    const width = this.svgGjengen.clientWidth
    gsap.set(gang, { width })

    const gangRect = gang.getBoundingClientRect()
    // const a69 = Dom.find('#ANIMATE-69')
    // const a69rect = a69.getBoundingClientRect()

    const spot = Dom.find('#POSITION-GJENGEN')
    const spotRect = spot.getBoundingClientRect()

    gsap.set(gang, { opacity: 1, left: this.parade.$el.scrollLeft + spotRect.x - (gangRect.width / 2) })
  }

  createDummyAnimationHandles () {
    this.$svgAnimations.forEach($svgAnim => {
      const clone = document.createElement('div')
      clone.dataset.animateTarget = $svgAnim.id
      const cRect = $svgAnim.getBoundingClientRect()
      this.$parade.appendChild(clone)

      const $clone = Dom.find(`[data-animate-target="${$svgAnim.id}"]`)
      this.$handles.push($clone)
      gsap.set($clone, {
        height: 5, width: cRect.width
      })
      // gsap.set($clone, { backgroundColor: 'pink' })
    })

    this.$handles.push(Dom.find('#gjengen'))
    this.$handles.push(Dom.find('#sykkel'))
  }

  createCSSAnimationsObserver () {
    const opts = {
      root: null, // Dom.find('.parade'), // relative to document viewport
      rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
      threshold: 0.0 // visible amount of item shown in relation to root
    }

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.hasAttribute('data-l')) {
            entry.target.firstElementChild.play()
            entry.target.classList.remove('stopped')
            console.debug('==> ANIMATION: Playing L', entry.target.id)
            return
          }
          const t = this.$svgAnimations.find(a => a.id === entry.target.dataset.animateTarget)
          t.classList.remove('stopped')
          console.debug('==> ANIMATION: Playing', t.id)
        } else {
          if (entry.target.hasAttribute('data-l')) {
            entry.target.firstElementChild.pause()
            entry.target.classList.add('stopped')
            console.debug('==> ANIMATION: Stopping L', entry.target.id)
            return
          }
          const t = this.$svgAnimations.find(a => a.id === entry.target.dataset.animateTarget)
          t.classList.add('stopped')
          console.debug('==> ANIMATION: Stopping', t.id)
        }
      })
    }, opts)

    Array.from(this.$handles).forEach(a => {
      this.observer.observe(a)
    })
  }

  start () {
    // this.svgGjengen.style.width = 'auto'
    this.createDummyAnimationHandles()
    this.repositionHandles()
    this.createCSSAnimationsObserver()

    Array.from(this.$animations).forEach(a => {
      const speed = a.dataset.animationSpeed
      const delay = a.dataset.animationDelay || 0
      const max = this.app.parade.maxScroll + window.innerWidth
      if (speed > 0) {
        gsap.to(a, {
          duration: 30 / speed,
          delay,
          ease: 'none',
          x: `+=${max}`, // move each box 500px to right
          modifiers: {
            x: gsap.utils.unitize(x => {
              if (x > max) {
                return 0
              }
              return x
            }) // force x value to be between 0 and 500 using modulus
          },
          repeat: -1
        })
      }
    })

    this.placeGang()
    this.placeBike()
    // SAFARI SUCKS
    setTimeout(() => {
      this.placeGang()
      this.placeBike()
    }, 2000)
  }

  repositionHandles () {
    this.$svgAnimations.forEach(svg => {
      const $clone = this.$handles.find(c => c.dataset.animateTarget === svg.id)
      if ($clone) {
        const cRect = svg.getBoundingClientRect()
        const x = cRect.x + this.parade.$el.scrollLeft
        const { y } = cRect

        gsap.set($clone, { x, y })
      }
    })
  }

  onResize () {
    this.repositionHandles()
    this.placeGang()
    this.placeBike()
  }
}
